import { configureStore } from '@reduxjs/toolkit';
import {
  avatarUrlReducer,
  formReducer,
  platformAvatarsReducer,
  userAvatarsReducer,
  voicesListReducer,
  platformScenesReducer,
  avatarReducer,
} from '../slices';

export const store = configureStore({
  reducer: {
    avatarForm: formReducer,
    iframeAddress: avatarUrlReducer,
    platformAvatars: platformAvatarsReducer,
    userAvatars: userAvatarsReducer,
    voicesList: voicesListReducer,
    platformScenes: platformScenesReducer,
    avatar: avatarReducer,
  },
});

export type IRootState = ReturnType<typeof store.getState>;
